<script>
    import IconProfile from '@/components/icon/IconProfile.vue';
    import constants from '@/constants';

    export default {
        data() {
            return {
                constants: constants,
            }
        },
        components: {
            ButtonIcon: IconProfile,
        }
    }
</script>


<template>
    <router-link 
        class="left_button_main_container"
        :to="{name: constants.ROUTER_NAME.USEREDIT}"    
    >
        <div class="left_button_icon_container">
            <ButtonIcon 
                iconWidth = "16px"
                iconHeight = "16px"
            />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">User & Role</label>
        </div>
    </router-link>
</template>